import { useMemo } from 'react';
export var useStepperControls = function useStepperControls(_ref) {
  var disabled = _ref.disabled,
    loading = _ref.loading,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 99 : _ref$max,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? 0 : _ref$min,
    tempValue = _ref.tempValue,
    onChange = _ref.onChange,
    _ref$value = _ref.value,
    valueProp = _ref$value === void 0 ? 1 : _ref$value;
  var value = Math.max(min, Math.min(valueProp, max));
  return useMemo(function () {
    return {
      prev: {
        disabled: disabled || tempValue <= min || loading,
        onClick: function onClick(e) {
          return onChange === null || onChange === void 0 ? void 0 : onChange(value - 1, e);
        }
      },
      next: {
        disabled: disabled || tempValue >= max || loading,
        onClick: function onClick(e) {
          return onChange === null || onChange === void 0 ? void 0 : onChange(value + 1, e);
        }
      }
    };
  }, [tempValue, disabled, max, min, loading]);
};